import { render, staticRenderFns } from "./callReason.vue?vue&type=template&id=b231f392"
import script from "./callReason.vue?vue&type=script&lang=js"
export * from "./callReason.vue?vue&type=script&lang=js"
import style0 from "./callReason.vue?vue&type=style&index=0&id=b231f392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports